/**
 * ConnectionLostOverlay
 *
 * Shows a clear, non-blamey overlay when we temporarily can't reach the AI service.
 * Prevents the session from looking "frozen" during reconnect attempts.
 */

import { useTranslation } from 'react-i18next';

interface ConnectionLostOverlayProps {
  onRetry?: () => void;
}

export default function ConnectionLostOverlay({ onRetry }: ConnectionLostOverlayProps) {
  const { t } = useTranslation();

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-30">
      <div className="text-center px-6 py-5 max-w-lg">
        <div className="inline-flex flex-col items-center gap-3 bg-black/55 backdrop-blur-md rounded-2xl px-8 py-6 border border-white/10">
          <div className="relative w-10 h-10">
            <div className="absolute inset-0 border-4 border-blue-500/30 border-t-blue-500 rounded-full animate-spin"></div>
          </div>

          <div className="space-y-1">
            <p className="text-white text-base font-semibold">
              {t('errors.connectionLost', 'Connection lost')}
            </p>
            <p className="text-white/80 text-sm">
              {t('errors.reconnecting', 'Reconnecting...')}
            </p>
          </div>

          {onRetry && (
            <button
              onClick={onRetry}
              className="mt-2 px-5 py-2 bg-white/10 hover:bg-white/15 text-white rounded-lg border border-white/15 transition-colors text-sm font-medium"
            >
              {t('common.buttons.retry', 'Try Again')}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}


